import { Libraries, useJsApiLoader } from '@react-google-maps/api';

const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY as string;
const googleMapId = process.env.REACT_APP_GOOGLE_MAP_ID as string;

const libraries: Libraries = ['places'];

export const useGoogleMapsApi = () => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapKey,
    mapIds: [googleMapId],
    libraries,
  });

  return { isLoaded, loadError, googleMapId };
};
